import { action, observable } from 'mobx'

export default class ActiveItemStore {
  @observable index = -1

  @action
  setIndex = (index: number) => {
    this.index = index
  }
}
